// Support email - centralized
export const SUPPORT_EMAIL = import.meta.env.VITE_SUPPORT_EMAIL ?? 'simplifiedtradingjournal@pm.me';

// AI usage limits - centralized and immutable
export const AI_LIMITS = Object.freeze({
  YEARLY_DAILY_QUESTIONS: 5
});

// Helper functions for consistent text generation
export function dailyLimitStr(count: number): string {
  return `maximum AI analysis features (${count} question${count === 1 ? '' : 's'} per day)`;
}

export function quotaDescriptionStr(count: number): string {
  return `yearly subscribers receive maximum AI features with up to ${count} question${count === 1 ? '' : 's'} per day`;
}